import React from 'react';
import { observer } from 'mobx-react';
import { Route, Switch } from 'react-router-dom';
import Grid from "@material-ui/core/Grid";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';
import MeetingRoomOutlinedIcon from '@material-ui/icons/MeetingRoomOutlined';
import MenuBookRoundedIcon from '@material-ui/icons/MenuBookRounded';
import SpeedIcon from '@material-ui/icons/Speed';
import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';

import NavigationListItem from './NavigationListItem';
import CycleSelector from './CycleSelector';
import {
  DashboardIcon, DemandIcon, SupplyIcon, FileIcon, RawIcon, ScenarioIcon,
  CycleWorkflowIcon,
} from '../../theme/AthenaIcons';
import { deleteToken } from '../../utils';
import currentUser, { logout } from '../../store/currentUser';
import { reloadCurrentUser } from '../../store/currentUser';


const styles = theme => ({
  container: {
    height: '100%',
  },
  subHeader: {
    textTransform: 'uppercase',
    color: 'white',
    fontSize: 12,
    lineHeight: 1,
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    userSelect: 'none',
  },
  logout: {
    fontSize: 12,
  },
  icon: {
    justifyContent: 'center',
    opacity: 0.6,
  },
  divider: {
    backgroundColor: theme.palette.common.white,
    opacity: 0.6,
  },
});


@withStyles(styles)
@observer
class Navigation extends React.Component {
  logout = async () => {
    await logout();
    deleteToken();
    await reloadCurrentUser();
  };

  render() {
    const { classes } = this.props;
    return (
      <Drawer variant="permanent">
        <Grid
          container
          direction="column"
          justify="space-between"
          wrap="nowrap"
          className={classes.container}
        >
          <Grid item>
            <Switch>
              <Route path="/parthenos/">
                <CycleSelector disabled />
              </Route>
              <Route path="*">
                <CycleSelector />
              </Route>
            </Switch>
            <List component="div">
              <NavigationListItem
                path={['/cockpits/', '/cockpits/demand-map', '/cockpits/supply-map']}
                exact
                title="GLOBAL COCKPITS"
              >
                <CycleWorkflowIcon fontSize="large" />
              </NavigationListItem>
            </List>
            <Divider light classes={{ root: classes.divider }} />
            <List component="div">
              <NavigationListItem path="/parthenos/" title="Parthenos">
                <AccountBalanceOutlinedIcon />
              </NavigationListItem>
              <ListSubheader className={classes.subHeader} component="div">
                Cycle management
              </ListSubheader>
              <NavigationListItem path="/" exact>
                <DashboardIcon fontSize="large"/>
              </NavigationListItem>
              <NavigationListItem path="/input-files/">
                <FileIcon fontSize="large"/>
              </NavigationListItem>
              <NavigationListItem path="/scenarios/">
                <ScenarioIcon fontSize="large"/>
              </NavigationListItem>
              <ListSubheader className={classes.subHeader} component="div">
                Detailed results
              </ListSubheader>
              <NavigationListItem
                path={['/demand/', '/demand/detail', '/demand/bridges']}
                exact
                title="Demand"
              >
                <DemandIcon fontSize="large"/>
              </NavigationListItem>
              <NavigationListItem
                path={['/supply/technology', '/supply/fg-sfg', '/supply/detail']}
                exact
                title="Supply"
              >
                <SupplyIcon fontSize="large"/>
              </NavigationListItem>
              <NavigationListItem
                path={['/raw-and-packs/', '/raw-and-packs/commitment', '/raw-and-packs/bom']}
                exact
                title="Raw & packs"
              >
                <RawIcon fontSize="large"/>
              </NavigationListItem>
              <NavigationListItem
                path={["/performance-monitoring/demand", "/performance-monitoring/supply"]}
                exact
                title="Performance"
              >
                <SpeedIcon />
              </NavigationListItem>
            </List>
          </Grid>
          <Grid item>
            {
              currentUser.is_active
                ? (
                  <List component="div">
                    <NavigationListItem
                      path="/help"
                      exact
                    >
                      <MenuBookRoundedIcon />
                    </NavigationListItem>
                    <Tooltip
                      title={`Logged as “${currentUser.toString()}”`}
                      placement="right"
                    >
                      <ListItem className={classes.subHeader} component="div">
                        <Typography variant="inherit" noWrap>
                          {currentUser.toString()}
                        </Typography>
                      </ListItem>
                    </Tooltip>
                    <ListItem button disableGutters onClick={this.logout} className={classes.logout}>
                      <ListItemIcon className={classes.icon}>
                        <MeetingRoomOutlinedIcon />
                      </ListItemIcon>
                      <ListItemText disableTypography>Logout</ListItemText>
                    </ListItem>
                  </List>
                )
                : null
            }
          </Grid>
        </Grid>
      </Drawer>
    );
  }
}


export default Navigation;
